export const apiBaseUrl = process.env.REACT_APP_BASE_URL;

export const clientBaseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000/"
    : process.env.REACT_APP_CLIENT_BASE_URL;
